export const toasterTypes = {
  success: 'success' as const,
  failure: 'failure' as const,
};
